export default function divideArrayIntoParts<T>(array: T[], partSize: number) {
  if (partSize <= 0) throw new Error('Part size must be greater than 0');

  return Array.from({ length: Math.ceil(array.length / partSize) }, (_, i) => {
    const start = i * partSize;
    return array.slice(start, start + partSize);
  });
}
